import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

const ForgotPassword = () => {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await requestPasswordReset(email);
      setSuccess(true);
    } catch (error) {
      console.error('Error al solicitar el restablecimiento de contraseña:', error);
      setError(
        error.message ||
          'Error al solicitar el restablecimiento de contraseña. Por favor, inténtalo de nuevo más tarde.',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Recuperar Contraseña</h2>
        </div>
        <div className="auth-body">
          {error && <div className="alert alert-error">{error}</div>}
          {success ? (
            <div className="success-message">
              <div className="success-icon">
                <span className="material-icons">email</span>
              </div>
              <h3>Email Enviado</h3>
              <p>
                Hemos enviado un enlace de recuperación a <strong>{email}</strong>. Por favor,
                revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu
                contraseña.
              </p>
              <p className="small">
                Si no recibes el email en unos minutos, revisa tu carpeta de spam o{' '}
                <button
                  type="button"
                  className="btn-link"
                  onClick={() => {
                    setSuccess(false);
                    setLoading(false);
                  }}
                >
                  inténtalo de nuevo
                </button>
                .
              </p>
              <div className="auth-actions">
                <Link to="/login" className="btn btn-primary btn-block">
                  Volver al Inicio de Sesión
                </Link>
              </div>
            </div>
          ) : (
            <>
              <p className="text-center">
                Ingresa tu dirección de email y te enviaremos un enlace para restablecer tu
                contraseña.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Ingresa tu email"
                    required
                  />
                </div>
                <div className="auth-actions">
                  <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
                  </button>
                  <Link to="/login" className="btn btn-link btn-block">
                    Volver al Inicio de Sesión
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
